import React, { useEffect, useRef, useState } from "react";
import {
  MapContainer,
  FeatureGroup,
} from "react-leaflet";
import { EditControl } from "react-leaflet-draw";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-draw/dist/leaflet.draw.css";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import { useParams, Link, useNavigate } from "react-router-dom";

import Selectlist from "../components/POI/Selectlist";
import { useTranslate } from "../hooks/LanguageProvider";
import {
  parseGeofenceAttributes,
  parseGeofencing,
  calculateSurfaceOrLength,
  Geofence,
  timeZoneDST,
} from "../utilities/functions";
import { toast, Bounce } from "react-toastify";
import { Button } from "react-bootstrap";

import { LocalizationProvider, DateTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import "dayjs/locale/fr"; // Support du français
import Select, { InputActionMeta } from "react-select";

import "leaflet/dist/leaflet.css";
import AsyncSelect from "react-select/async";
import { PropagateLoader } from "react-spinners";
import MapModal from "../components/Map/MapModal";
import ReactPaginate from "react-paginate";
import BaseMapLayerControl from "../components/Map/BaseMapLayerControl";
import { useBaseMapPreference } from "../hooks/useBaseMapPreference";
import "../assets/css/geofence-map.css";

L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});
const backendUrl = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";

// interface Geofence {
//     id: number;
//     type: "circle" | "polygon" | "polyline" | "marker" | "rectangle";
//     center?: [number, number];
//     radius?: number;
//     positions?: [number, number][];
//     position?: [number, number];
// }

interface SearchResult {
  lat: string;
  lon: string;
  display_name: string;
}

interface UserInterface {
  id_user: number;
  nom_user: string;
  prenom_user: string;
}

// Définition du type pour les options de react-select
type SelectOption = {
  value: { lat: number; lon: number };
  label: string;
};

interface GeofenceCalcule {
  id: number;
  type: "circle" | "polygon" | "polyline" | "marker" | "rectangle";
  positions?: [number, number][]; // La propriété positions peut être optionnelle
}

interface POIInterface {
  idgeof: number;
  codegeof: string;
  namegeof: string;
  descriptiongeof: string;
  username_user?: string;
  etatgeof: string;
  areageof: string;
  datecreategeof: string;
  tolerance: number;
  user_id: number;
}

interface Vehicle {
  id_vehicule: number;
  category_vehicule: string;
  couleur_vehicule: string;
  nom_groupe: string;
  id_conducteur_vehicule: number;
  id_dispositif: number;
  id_groupe: number;
  id_marque: number | null;
  id_user: number;
  immatriculation_vehicule: string;
  num_porte_vehicule: string;
  vehicule_type: string;
  draft: number;
  ALT: number;
  LAT: number;
  LON: number;
  TIMESTAMP: string; // ISO date string format
  ENGINESTAT: number; // 1 or 0 (assuming binary state)
  entry_date: string;
  entry_lat: number;
  entry_lon: number;
  exit_date: string;
  exit_lat: number;
  exit_lon: number;
}


interface GroupInterface {
  id_groupe: number;
  nom_groupe: string;
}

const POI: React.FC = () => {
  const mapRef = useRef<L.Map | null>(null);
  const editControlRef = useRef<any>(null);
  const featureGroupRef = useRef<any>(null);
  const [baseMap, setBaseMap] = useBaseMapPreference("geofence");
  const [step, setStep] = useState(1);
  const { translate } = useTranslate();
  const id_user = localStorage.getItem("userid");
  const { id_poi } = useParams<{ id_poi?: string }>();
  let [POI, setPOI] = useState<POIInterface>({
    idgeof: parseInt(id_poi ?? "0", 10),
    codegeof: "",
    namegeof: "",
    descriptiongeof: "",
    etatgeof: "",
    areageof: "",
    datecreategeof: "",
    tolerance: 0,
    user_id: parseInt(id_user ?? "0", 10),
  });

  // ✅ Remplacement de Flatpickr par MUI DatePicker
  const [startDate, setStartDate] = useState<Dayjs>(dayjs().startOf("day"));
  const [endDate, setEndDate] = useState<Dayjs>(dayjs().endOf("day"));
  let [limitValue, setSelectedLimitValue] = useState(15);

  const navigate = useNavigate();
  let [geofences, setGeofences] = useState<Geofence[]>([]);
  const [upadteCodegeof, setUpadtecodegeof] = useState("");
  const [buttonClicked, setButtonClicked] = useState(false);
  const [mapCenter, setMapCenter] = useState<[number, number]>([30.5670197, 4.6911217]);
  const [mapZoom, setMapZoom] = useState<number>(6);
  const [usersOptions, setUsersOptions] = useState<any[]>([{ value: "Aucun", label: "Aucun" },]);
  const [groupsOptions, setGroupsOptions] = useState<any[]>([{ value: "Aucun", label: "Aucun" },]);
    const [groups, setGroups] = useState<GroupInterface[]>([]);
  const [Users, setUsers] = useState<UserInterface[]>([]);
  const [user, setUser] = useState<UserInterface>({
    id_user: parseInt(id_user ?? "0", 10) || 0,
    nom_user: "",
    prenom_user: "",
  });

  const [groupId, setGroupId] = useState(0);


  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Nombre d'éléments par page
  const [searchTerm, setSearchTerm] = useState(""); // État pour la recherche

  const [modalInfo, setModalInfo] = useState<{
    show: boolean;
    lat: number;
    lng: number;
  }>({ show: false, lat: 0, lng: 0 });


  

  const handlePageClick = (data: any) => {
    const selectedPage = data.selected + 1; // ReactPaginate utilise 0-indexed pages
    setCurrentPage(selectedPage);
    const offset = (selectedPage - 1) * 10; // Calcul du décalage pour 10 véhicules par page
    const currentPageVehicles = vehicles.slice(offset, offset + 10);
    setCurrentVehicles(currentPageVehicles); // Met à jour les véhicules pour cette page
  };


  let result: number = 0;
  let resultType = "Surface";

  const verifyUsername = () => {
    // Votre logique pour vérifier le nom d'utilisateur ici
  };

  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(false);

  // Filtrer les véhicules par immatriculation
  const filteredVehicles = vehicles.filter((vehicle: Vehicle) =>
    vehicle.immatriculation_vehicule
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );
  let [currentVehicles, setCurrentVehicles] = useState(vehicles.slice(0, 15)); // Initialisation des véhicules à afficher

  // Calcule les indices pour la pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  currentVehicles = filteredVehicles.slice(indexOfFirstItem, indexOfLastItem);

  // Nombre total de pages
  const totalPages = Math.ceil(filteredVehicles.length / itemsPerPage);
  const handleCreated = (e: any) => {
    const { layerType, layer } = e;

    let newGeofence: Geofence = {
      id: layer._leaflet_id,
      type: layerType,
    };

    if (layerType === "circle") {
      const center = layer.getLatLng();
      newGeofence = {
        ...newGeofence,
        center: [center.lat, center.lng], // Convert LatLng to [number, number]
        radius: layer.getRadius(),
      };
    } else if (layerType === "polygon" || layerType === "rectangle") {
      newGeofence = {
        ...newGeofence,
        positions: layer
          .getLatLngs()[0]
          .map((latlng: L.LatLng) => [latlng.lat, latlng.lng]), // Convert LatLngs to [number, number]
      };
    } else if (layerType === "polyline") {
      newGeofence = {
        ...newGeofence,
        positions: layer
          .getLatLngs()
          .map((latlng: L.LatLng) => [latlng.lat, latlng.lng]), // Convert LatLngs to [number, number]
      };
    } else if (layerType === "marker") {
      const position = layer.getLatLng();
      newGeofence = {
        ...newGeofence,
        position: [position.lat, position.lng], // Convert LatLng to [number, number]
      };
    }

    setGeofences((prevGeofences) => [...prevGeofences, newGeofence]);

    //refreshPOI([newGeofence]);
  };

  const handleEdited = (e: any) => {
    const layers = e.layers;
    const updatedGeofences: Geofence[] = [];

    layers.eachLayer((layer: any) => {
      const layerId = layer._leaflet_id;
      let updatedGeofence: Geofence | null = null;

      if (layer instanceof L.Circle) {
        const center = layer.getLatLng();
        updatedGeofence = {
          id: layerId,
          type: "circle",
          center: [center.lat, center.lng], // Convert LatLng to [number, number]
          radius: parseFloat(layer.getRadius().toFixed(2)),
        };
      } else if (layer instanceof L.Polygon || layer instanceof L.Rectangle) {
        const latlngs = layer.getLatLngs();
        if (layer instanceof L.Rectangle) {
          // Rectangle should have two corner points
          const corners = latlngs as L.LatLng[];
          if (corners.length === 2) {
            const [corner1, corner2] = corners;
            updatedGeofence = {
              id: layerId,
              type: "rectangle",
              positions: [
                [corner1.lat, corner1.lng],
                [corner2.lat, corner2.lng],
              ], // Convert LatLngs to [number, number]
            };
          }
        } else {
          // Handle polygons
          updatedGeofence = {
            id: layerId,
            type: "polygon",
            positions:
              Array.isArray(latlngs) && Array.isArray(latlngs[0])
                ? (latlngs[0] as L.LatLng[]).map((latlng: L.LatLng) => [
                    latlng.lat,
                    latlng.lng,
                  ]) // Convert LatLngs to [number, number]
                : [], // Handle case where latlngs is not an array or is empty
          };
        }
      } else if (layer instanceof L.Polyline) {
        const latlngs = layer.getLatLngs();
        updatedGeofence = {
          id: layerId,
          type: "polyline",
          positions: Array.isArray(latlngs)
            ? (latlngs as L.LatLng[]).map((latlng: L.LatLng) => [
                latlng.lat,
                latlng.lng,
              ]) // Convert LatLngs to [number, number]
            : [], // Handle case where latlngs is not an array
        };
      } else if (layer instanceof L.Marker) {
        const position = layer.getLatLng();
        updatedGeofence = {
          id: layerId,
          type: "marker",
          position: [position.lat, position.lng], // Convert LatLng to [number, number]
        };
      }

      if (updatedGeofence) {
        updatedGeofences.push(updatedGeofence);
      }
    });

    // Update geofences state with the updated geofences
    setGeofences((prevGeofences) =>
      prevGeofences.map(
        (geofence) =>
          updatedGeofences.find((updated) => updated.id === geofence.id) ||
          geofence
      )
    );

    // Call refreshPOI with the updated geofences
    refreshPOI(updatedGeofences);
  };

  function calculateCenter(geofences: GeofenceCalcule[]): [number, number] {
    let minLat = Infinity;
    let maxLat = -Infinity;
    let minLng = Infinity;
    let maxLng = -Infinity;

    geofences.forEach((geofence) => {
      if (geofence.positions) {
        geofence.positions.forEach(([lat, lng]) => {
          minLat = Math.min(minLat, lat);
          maxLat = Math.max(maxLat, lat);
          minLng = Math.min(minLng, lng);
          maxLng = Math.max(maxLng, lng);
        });
      }
    });

    return [(minLat + maxLat) / 2, (minLng + maxLng) / 2];
  }

  function calculateZoom(geofences: Geofence[]): number {
    const WORLD_DIM = { height: 256, width: 256 };
    const ZOOM_MAX = 21;

    let minLat = Infinity;
    let maxLat = -Infinity;
    let minLng = Infinity;
    let maxLng = -Infinity;

    geofences.forEach((geofence) => {
      if (geofence.positions) {
        geofence.positions.forEach(([lat, lng]) => {
          minLat = Math.min(minLat, lat);
          maxLat = Math.max(maxLat, lat);
          minLng = Math.min(minLng, lng);
          maxLng = Math.max(maxLng, lng);
        });
      }
    });

    const latFraction = (maxLat - minLat) / 180;
    const lngFraction = (maxLng - minLng) / 360;

    const latZoom = Math.floor(Math.log2(WORLD_DIM.height / 256 / latFraction));
    const lngZoom = Math.floor(Math.log2(WORLD_DIM.width / 256 / lngFraction));

    return Math.min(latZoom, lngZoom, ZOOM_MAX);
  }

  const getPOI = async (idPoi: string, idUser: string) => {
    try {
      const bodyData = JSON.stringify({
        id_poi: idPoi,
        id_user: idUser,
      });

      const POIResponse = await fetch(`${backendUrl}/api/poi/find`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: bodyData,
        mode: "cors",
      });

      if (!POIResponse.ok) {
        console.error("Erreur lors de la récupération du POI");
        return;
      }

      const data = await POIResponse.json();

      const mappedGeofences = data.map((item: POIInterface) => {
        return parseGeofenceAttributes(item.areageof, item.idgeof);
      });

      setPOI(data[0]);
      POI = data[0];
      if (POI) setUpadtecodegeof(POI?.codegeof);
      setGeofences(mappedGeofences);

      let center: [number, number] = [51.505, -0.09];
      let zoom: number = 13;

      const geofenceWithCenter = mappedGeofences.find(
        (geofence: Geofence) =>
          (geofence.type === "circle" || geofence.type === "marker") &&
          geofence.center
      );

      if (geofenceWithCenter) {
        center = geofenceWithCenter.center!;
        zoom = 16;
      } else {
        const geofenceWithPositions = mappedGeofences.find(
          (geofence: Geofence) =>
            (geofence.type === "polygon" ||
              geofence.type === "polyline" ||
              geofence.type === "rectangle") &&
            geofence.positions
        );

        if (geofenceWithPositions) {
          center = calculateCenter([geofenceWithPositions]);
          zoom = calculateZoom([geofenceWithPositions]);
        }
      }

      setMapCenter(center);
      setMapZoom(zoom);

      try {
        if (POI) {
          const geofence = parseGeofencing(POI?.areageof);
          result = calculateSurfaceOrLength(geofence);
          if (geofence.type === "LINESTRING") {
            resultType = "Longueur";
          }
        }
      } catch (error) {
        console.error(error);
        resultType = "Erreur";
      }

      if (mapRef.current) {
        mapRef.current.setView(center, zoom);
      }
    } catch (error) {
      console.error(error);
    }
  };

  /*************************************************************************************************** */

  const refreshMapFromPOI = () => {
    try {
      if (POI) {
        // Analyser les géofences à partir de POI.areageof
        const mappedGeofences = parseGeofenceAttributes(
          POI.areageof,
          POI.idgeof
        );

        // Si mappedGeofences est un tableau, utilisez-le directement ; sinon, convertissez-le en tableau
        const geofencesArray = Array.isArray(mappedGeofences)
          ? mappedGeofences
          : [mappedGeofences];

        // Mettre à jour l'état des géofences avec les géofences du POI
        setGeofences(geofencesArray);

        // Déterminer le centre et le zoom de la carte en fonction des géofences
        let center: [number, number] = [51.505, -0.09];
        let zoom: number = 13;

        const geofenceWithCenter = geofencesArray.find(
          (geofence: Geofence) =>
            (geofence.type === "circle" || geofence.type === "marker") &&
            geofence.center
        );

        if (geofenceWithCenter && geofenceWithCenter.center) {
          center = geofenceWithCenter.center;
          zoom = 16;
        } else {
          const geofenceWithPositions = geofencesArray.find(
            (geofence: Geofence) =>
              (geofence.type === "polygon" ||
                geofence.type === "polyline" ||
                geofence.type === "rectangle") &&
              geofence.positions
          );

          if (geofenceWithPositions && geofenceWithPositions.positions) {
            center = calculateCenter([geofenceWithPositions]);
            zoom = calculateZoom([geofenceWithPositions]);
          }
        }

        // Mettre à jour le centre et le zoom de la carte
        setMapCenter(center);
        setMapZoom(zoom);

        // Mettre à jour la vue de la carte
        if (mapRef.current) {
          mapRef.current.setView(center, zoom);
        }

        // Recharger les géofences sur la carte sans utiliser updateGeofencesOnMap
        if (featureGroupRef.current) {
          // Effacer les couches existantes du groupe de fonctionnalités
          featureGroupRef.current.clearLayers();

          // Parcourir les géofences et les ajouter au groupe de fonctionnalités
          geofencesArray.forEach((geofence) => {
            let layer: L.Layer | null = null;

            if (geofence.type === "circle" && geofence.center) {
              layer = L.circle(geofence.center, { radius: geofence.radius });
            } else if (geofence.type === "polygon" && geofence.positions) {
              layer = L.polygon(geofence.positions);
            } else if (geofence.type === "rectangle" && geofence.positions) {
              if (geofence.positions.length === 2) {
                const bounds: L.LatLngBoundsLiteral = [
                  [geofence.positions[0][0], geofence.positions[0][1]],
                  [geofence.positions[1][0], geofence.positions[1][1]],
                ];
                layer = L.rectangle(bounds);
              } else {
                layer = L.polygon(geofence.positions);
              }
            } else if (geofence.type === "polyline" && geofence.positions) {
              layer = L.polyline(geofence.positions);
            } else if (geofence.type === "marker" && geofence.position) {
              layer = L.marker(geofence.position);
            }

            if (layer) {
              // Ajouter le layer au groupe de fonctionnalités
              featureGroupRef.current.addLayer(layer);
            }
          });
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const refreshPOI = (updatedGeofences: Geofence[]) => {
    // Update the state of the geofences with the new data
    setGeofences(updatedGeofences);

    // Convert the updated geofences into a string for the `areageof` field
    const newAreageof = convertGeofencesToAreageof(updatedGeofences);

    // Update the POI state with the new `areageof` value
    setPOI((prevPOI) => {
      if (!prevPOI) {
        return {
          // Provide default values for all properties of POIInterface
          areageof: "",
          idgeof: 0,
          codegeof: "",
          namegeof: "",
          descriptiongeof: "",
          username_user: "",
          etatgeof: "",
          datecreategeof: "",
          tolerance: 0,
          user_id: 0,
        };
      }

      return {
        ...prevPOI,
        areageof: newAreageof,
      };
    });

    // Clear existing layers from the feature group
    if (featureGroupRef.current) {
      featureGroupRef.current.clearLayers();

      // Redraw the updated geofences on the map
      const updateGeofencesOnMap = (updatedGeofences: Geofence[]) => {
        // Check if featureGroupRef is defined and the map is ready
        if (featureGroupRef.current) {
          // Iterate over each updated geofence
          updatedGeofences.forEach((geofence) => {
            let layer: L.Layer | null = null;

            // Determine the type of geofence and create the appropriate layer
            if (
              geofence.type === "circle" &&
              geofence.center &&
              geofence.radius
            ) {
              // Create a circle with the specified center and radius
              layer = L.circle(geofence.center, { radius: geofence.radius });
            } else if (geofence.type === "polygon" && geofence.positions) {
              // Create a polygon with the specified positions
              layer = L.polygon(geofence.positions);
            } else if (geofence.type === "rectangle" && geofence.positions) {
              // Create a rectangle with the specified corners (positions)
              // Assuming `geofence.positions` is an array of two tuples: [ [lat1, lng1], [lat2, lng2] ]
              if (geofence.positions.length === 2) {
                // Convert positions to LatLngBoundsExpression
                const bounds: L.LatLngBoundsLiteral = [
                  [geofence.positions[0][0], geofence.positions[0][1]], // South-West corner
                  [geofence.positions[1][0], geofence.positions[1][1]], // North-East corner
                ];
                layer = L.rectangle(bounds);
              }
            } else if (geofence.type === "polyline" && geofence.positions) {
              // Create a polyline with the specified positions
              layer = L.polyline(geofence.positions);
            } else if (geofence.type === "marker" && geofence.position) {
              // Create a marker with the specified position
              layer = L.marker(geofence.position);
            }

            // Add the layer to featureGroupRef if it is defined
            if (layer) {
              featureGroupRef.current.addLayer(layer);
            }
          });
        }
      };
    }
  };

  let newGeofences: Geofence[];

  // Supposons que vous ayez une fonction qui manipule un layer
  const saveCurrentGeofences = () => {
    const layers = featureGroupRef.current?.getLayers() || [];

    // Assigner le type `L.Layer` au paramètre `layer`
    newGeofences = layers
      .map((layer: L.Layer) => {
        const leafletId = L.Util.stamp(layer); // Utilisation de L.Util.stamp() pour obtenir l'ID

        // Vérification du type spécifique du layer
        if (layer instanceof L.Circle) {
          const latLng = layer.getLatLng();
          return {
            id: leafletId,
            type: "circle",
            center: [latLng.lat, latLng.lng], // Assurez-vous que center est un tableau [lat, lng]
            radius: layer.getRadius(),
          };
        } else if (layer instanceof L.Polygon || layer instanceof L.Rectangle) {
          const latLngs = layer.getLatLngs() as L.LatLng[][]; // Peut être un tableau de tableaux
          const positions = latLngs
            .flat()
            .map((latLng) => [latLng.lat, latLng.lng] as [number, number]);
          return {
            id: leafletId,
            type: layer instanceof L.Polygon ? "polygon" : "rectangle",
            positions,
          };
        } else if (layer instanceof L.Polyline) {
          const latLngs = layer.getLatLngs() as L.LatLng[];
          const positions = latLngs.map(
            (latLng) => [latLng.lat, latLng.lng] as [number, number]
          );
          return {
            id: leafletId,
            type: "polyline",
            positions,
          };
        } else if (layer instanceof L.Marker) {
          const latLng = layer.getLatLng();
          return {
            id: leafletId,
            type: "marker",
            position: [latLng.lat, latLng.lng], // Assurez-vous que position est un tableau [lat, lng]
          };
        }

        // Si ce n'est pas un type supporté, retourner null
        return null;
      })
      .filter(Boolean) as Geofence[];

    refreshPOI(newGeofences);
  };

  useEffect(() => {
    loadGeofencesToMap();
  }, [step]);

  const loadGeofencesToMap = () => {
    if (featureGroupRef.current) {
      featureGroupRef.current.clearLayers();

      geofences.forEach((geofence) => {
        if (geofence.type === "circle" && geofence.center && geofence.radius) {
          L.circle(geofence.center, { radius: geofence.radius }).addTo(
            featureGroupRef.current
          );
        } else if (geofence.type === "polygon" && geofence.positions) {
          L.polygon(geofence.positions).addTo(featureGroupRef.current);
        }
      });
    }
  };

  const extractLatLng = (
    latLngString: string
  ): { lat: number; lng: number } => {
    const match = latLngString.match(/LatLng\(([^,]+),\s*([^)]+)\)/);
    let lat = 0;
    let lng = 0;
    if (match) {
      lat = parseFloat(match[1]);
      lng = parseFloat(match[2]);
    }
    return { lat, lng };
  };

  const convertLatLngArray = (latLngArray: [number, number][]): string =>
    latLngArray.map(([lat, lng]) => `${lat} ${lng}`).join(",");

  const convertLatLngLINESTRINGArray = (
    latLngArray: [number, number][]
  ): string => latLngArray.map(([lat, lng]) => `${lat} ${lng}`).join(", ");

  const convertGeofencesToAreageof = (geofences: Geofence[]): string => {
    const geofenceStrings = geofences
      .map((geofence) => {
        switch (geofence.type) {
          case "circle":
            if (
              geofence.center &&
              typeof geofence.center[0] === "number" &&
              typeof geofence.center[1] === "number" &&
              geofence.radius
            ) {
              const [lat, lng] = geofence.center;
              return `CIRCLE(${lat},${lng},${geofence.radius})`;
            }
            return "";

          case "polygon":
            if (geofence.positions && Array.isArray(geofence.positions)) {
              const positions = convertLatLngArray(geofence.positions);
              return `POLYGON((${positions}))`;
            }
            return "";

          case "rectangle":
            if (geofence.positions && Array.isArray(geofence.positions)) {
              const positions = convertLatLngArray(geofence.positions);
              return `RECTANGLE(${positions})`;
            }
            return "";

          case "polyline":
            if (geofence.positions && Array.isArray(geofence.positions)) {
              const positions = convertLatLngLINESTRINGArray(
                geofence.positions
              );
              return `LINESTRING(${positions})`;
            }
            return "";

          case "marker":
            if (
              geofence.position &&
              typeof geofence.position[0] === "number" &&
              typeof geofence.position[1] === "number"
            ) {
              const [lat, lng] = geofence.position;
              return `MARKER(${lat},${lng})`;
            }
            return "";

          default:
            return "";
        }
      })
      .filter((str) => str.length > 0);

    return geofenceStrings.join("; ");
  };

  useEffect(() => {
    if (id_poi && id_user) {
      getPOI(id_poi, id_user);
    }
  }, []);

  const addPOI = () => {
    saveCurrentGeofences();
    // console.log("Step 2");
    // console.log(POI.areageof);

    setStep(2);
  };

  const wizardBack = () => {
    // saveCurrentGeofences()

    // if(id_poi && id_user)   getPOI(id_poi, id_user);

    setStep(step - 1);

    setTimeout(() => {
      refreshMapFromPOI();
    }, 300);

    // console.log("Step 1");
    // console.log(POI.areageof);;
  };

  const findUserById = (
    id: number
  ): { value: number; label: string } | undefined => {
    const foundUser = Users.find((user) => user.id_user === id);

    if (foundUser) {
      const { id_user, nom_user, prenom_user } = foundUser;
      return { value: id_user, label: `${nom_user} ${prenom_user || ""}` };
    }

    return undefined;
  };

  useEffect(() => {
    if (id_user) {
      getUser(id_user);
    }
  }, [id_user]);

  const getUser = async (user_id: any) => {
    try {
      const res = await fetch(`${backendUrl}/api/users/find/${user_id}`, {
        mode: "cors",
      });

      if (!res.ok) {
        console.error("Erreur lors de la récupération des utilisateurs");
        return;
      }

      const usersData = await res.json();
      setUsers(usersData);

      const usersOptionsData = usersData.map((user: any) => ({
        value: user.id_user,
        label: `${user.nom_user} ${user.prenom_user || ""}`,
      }));

      setUsersOptions(usersOptionsData);
    } catch (error) {
      console.error("Erreur lors de la récupération des utilisateurs", error);
    }
  };
  
  const getGroup = async (user_id: any) => {
    try {
      const res = await fetch(
        `${backendUrl}/api/groups-vehicule/groups/${user_id}`,
        { mode: "cors" }
      );

      if (!res.ok) {
        console.error("Erreur lors de la récupération des groupes");
        return;
      }

      const groupsData = await res.json();
      setGroups(groupsData);

      const groupsOptionsData = groupsData.map((group: any) => ({
        value: group.id_groupe,
        label: `${group.nom_groupe || ""}`,
      }));

      setGroupsOptions(groupsOptionsData);
    } catch (error) {
      console.error("Erreur lors de la récupération des utilisateurs", error);
    }
  };

   useEffect(() => {
    
      if (id_user) {
        getGroup(id_user);
  
      }
    }, []);
  


  const findGroupById = (
    id: number
  ): { value: number; label: string } | undefined => {
    const foundGroup = groups.find((group) => group.id_groupe === id);

    if (foundGroup) {
      const { id_groupe, nom_groupe } = foundGroup;
      return { value: id_groupe, label: `${nom_groupe || ""}` };
    }

    return undefined;
  };

  const handleClick = async () => {
    if (POI) {
      await updatePOI(POI);
    } else {
      console.warn("POI is not defined or empty");
    }
  };

  const updatePOI = async (poi: POIInterface) => {
    const isCodeValid = poi.codegeof.trim().length > 0;
    const isNameValid = poi.namegeof.trim().length > 0;
    const isAreaValid = poi.areageof.trim().length > 0;

    if (!isNameValid || !isAreaValid || !isCodeValid) {
      const nameElement = document.getElementById("namegeof");
      if (nameElement) {
        nameElement.style.borderColor = isNameValid ? "#ced4da" : "red";
      }

      const areaElement = document.getElementById("areageof");
      if (areaElement) {
        areaElement.style.borderColor = isAreaValid ? "#ced4da" : "red";
      }

      const codegeofElement = document.getElementById("codegeof");
      if (codegeofElement) {
        codegeofElement.style.borderColor = isCodeValid ? "#ced4da" : "red";
      }

      toast.warn("Please fill in all required fields", {
        position: "bottom-right",
        autoClose: 2400,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
      setButtonClicked(true);
      return;
    } else {
      try {
        const resCheck = await fetch(`${backendUrl}/api/poi/check`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          mode: "cors",
          body: JSON.stringify({
            codegeof: poi.codegeof,
            updatedCodeGeof: upadteCodegeof,
            updated: upadteCodegeof === poi.codegeof ? 0 : 1,
          }),
        });

        if (!resCheck.ok) {
          throw new Error("Network response was not ok");
        }

        const jsonResponse = await resCheck.json();

        // eslint-disable-next-line eqeqeq
        if (jsonResponse.poi_count == 0) {
          const resUpdate = await fetch(`${backendUrl}/api/poi/update`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            mode: "cors",
            body: JSON.stringify({
              idgeof: poi.idgeof,
              codegeof: poi.codegeof,
              namegeof: poi.namegeof,
              descriptiongeof: poi.descriptiongeof,
              etatgeof: poi.etatgeof,
              areageof: poi.areageof,
              tolerance: poi.tolerance,
              user_id: poi.user_id,
            }),
          });

          if (!resUpdate.ok) {
            toast.warn("Can't update POI", {
              position: "bottom-right",
              autoClose: 2400,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              transition: Bounce,
            });
            console.error("Error updating POI");
            return;
            setButtonClicked(false);
          }

          toast.success("POI updated successfully", {
            position: "bottom-right",
            autoClose: 2400,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
          });
          setButtonClicked(false);

          navigate("/POIs");
        } else {
          toast.warn("The POI exists", {
            position: "bottom-right",
            autoClose: 2400,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
          });
          setButtonClicked(false);
        }
      } catch (error) {
        toast.warn("Can't update POI", {
          position: "bottom-right",
          autoClose: 2400,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        setButtonClicked(false);
      }
    }
  };

  const createPOI = async (poi: POIInterface) => {
    const isCodeValid = poi.codegeof.trim().length > 0;
    const isNameValid = poi.namegeof.trim().length > 0;
    const isAreaValid = poi.areageof.trim().length > 0;

    if (!isNameValid || !isAreaValid || !isCodeValid) {
      const nameElement = document.getElementById("namegeof");
      if (nameElement) {
        nameElement.style.borderColor = isNameValid ? "#ced4da" : "red";
      }

      const areaElement = document.getElementById("areageof");
      if (areaElement) {
        areaElement.style.borderColor = isAreaValid ? "#ced4da" : "red";
      }

      const codegeofElement = document.getElementById("codegeof");
      if (codegeofElement) {
        codegeofElement.style.borderColor = isCodeValid ? "#ced4da" : "red";
      }

      toast.warn("Please fill in all required fields", {
        position: "bottom-right",
        autoClose: 2400,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
      setButtonClicked(false);

      return;
    } else {
      try {
        const resCheck = await fetch(`${backendUrl}/api/poi/check`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          mode: "cors",
          body: JSON.stringify({
            codegeof: poi.codegeof,
            updatedCodeGeof: upadteCodegeof,
            updated: 0,
          }),
        });

        if (!resCheck.ok) {
          throw new Error("Network response was not ok");
        }

        const jsonResponse = await resCheck.json();

        if (jsonResponse.poi_count === 0) {
          let poiData = Object.fromEntries(
            Object.entries(poi).filter(([_, value]) => value !== null)
          );

          const resCreate = await fetch(`${backendUrl}/api/poi/create`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            mode: "cors",
            body: JSON.stringify({
              codegeof: poi.codegeof,
              namegeof: poi.namegeof,
              descriptiongeof: poi.descriptiongeof,
              etatgeof: "Inactive",
              areageof: poi.areageof,
              tolerance: poi.tolerance,
              user_id: poi.user_id,
            }),
          });

          if (!resCreate.ok) {
            toast.warn("Can't create POI", {
              position: "bottom-right",
              autoClose: 2400,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              transition: Bounce,
            });
            console.error("Error creating POI");
            return;

            setButtonClicked(false);
          }

          toast.success("POI created successfully", {
            position: "bottom-right",
            autoClose: 2400,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
          });

          setButtonClicked(false);

          navigate("/POIs");
        } else {
          toast.warn("The POI exists", {
            position: "bottom-right",
            autoClose: 2400,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
          });
          setButtonClicked(false);
        }
      } catch (error) {
        toast.warn("Can't create POI", {
          position: "bottom-right",
          autoClose: 2400,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        setButtonClicked(false);
      }
    }
  };

  const fetchVehicles = async (
    geofence: string,
    geofenceType: string,
    startDate: string,
    endDate: string
  ) => {
    const isGeofenceValid = geofence.trim().length > 0;
    const isStartDateValid = startDate.trim().length > 0;
    const isEndDateValid = endDate.trim().length > 0;

    setLoading(true);

    // Validation des champs
    if (!isGeofenceValid || !isStartDateValid || !isEndDateValid) {
      const geofenceElement = document.getElementById("geofence");
      if (geofenceElement) {
        geofenceElement.style.borderColor = isGeofenceValid ? "#ced4da" : "red";
      }

      const startDateElement = document.getElementById("startDate");
      if (startDateElement) {
        startDateElement.style.borderColor = isStartDateValid
          ? "#ced4da"
          : "red";
      }

      const endDateElement = document.getElementById("endDate");
      if (endDateElement) {
        endDateElement.style.borderColor = isEndDateValid ? "#ced4da" : "red";
      }

      toast.warn("Please fill in all required fields", {
        position: "bottom-right",
        autoClose: 2400,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
      setLoading(false);

      return;
    }

    try {
      // Requête pour récupérer les véhicules
      const res = await fetch(`${backendUrl}/api/vehicle/check-geofencing`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        mode: "cors",
        body: JSON.stringify({
          geofence: geofence,
          geofenceType: geofenceType,
          startDate: startDate,
          endDate: endDate,
          id_user,
          id_groupe:groupId
        }),
      });

      if (!res.ok) {
        setLoading(false);
        throw new Error("Network response was not ok");
      }

      const vehicles = await res.json();

      if (vehicles.length > 0) {
        toast.success("Vehicles fetched successfully", {
          position: "bottom-right",
          autoClose: 2400,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });

        console.log("Vehicles:", vehicles);

        setVehicles(vehicles);

        setLoading(false);

        return vehicles;
      } else {
        setLoading(false);
        toast.warn("No vehicles found for the given geofence and date range", {
          position: "bottom-right",
          autoClose: 2400,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching vehicles:", error);
      toast.error("Failed to fetch vehicles", {
        position: "bottom-right",
        autoClose: 2400,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    }
  };

  useEffect(() => {
    if (mapRef.current && geofences.length > 0) {
      const featureGroup = featureGroupRef.current;
      featureGroup.clearLayers();

      geofences.forEach((geofence) => {
        let layer;
        if (geofence.type === "circle" && geofence.center && geofence.radius) {
          layer = L.circle(geofence.center, { radius: geofence.radius });
        } else if (geofence.type === "polygon" && geofence.positions) {
          layer = L.polygon(geofence.positions);
        } else if (geofence.type === "polyline" && geofence.positions) {
          layer = L.polyline(geofence.positions);
        } else if (geofence.type === "marker" && geofence.position) {
          layer = L.marker(geofence.position);
        }

        if (layer) {
          featureGroup.addLayer(layer);
        }
      });

      setTimeout(() => {
        if (editControlRef.current) {
          editControlRef.current._toolbars.edit._checkDisabled();
        }
      }, 100);
    }
  }, [geofences]);

  const handleChange = (name: any, value: any) => {
    if (POI) {
      setPOI({
        ...POI,
        [name]: value,
      });
    }
  };

  const handleStartDateChange = (newDate: Dayjs | null) => {
    if (newDate) {
      if (newDate.isAfter(endDate)) {
        console.warn(
          "⚠️ La date de début ne peut pas dépasser la date de fin !"
        );
        return;
      }

      setStartDate(newDate);
    }
  };

  const handleEndDateChange = (newDate: Dayjs | null) => {
    if (newDate) {
      if (newDate.isBefore(startDate)) {
        console.warn(
          "⚠️ La date de fin ne peut pas être avant la date de début !"
        );
        return;
      }

      setEndDate(newDate);
      // Mise à jour vers `NewReport`
    }
  };

  type Option = {
    value: string;
    label: string;
    lat: number;
    lon: number;
  };

  const [selectedOption, setSelectedOption] = useState<Option | null>(null);
  // Fonction pour récupérer des adresses via Mapbox Geocoding API
  const fetchLocations = async (inputValue: string): Promise<Option[]> => {
    if (!inputValue.trim()) {
      return [];
    }

    const accessToken =
      "pk.eyJ1IjoiaWRlbmV0IiwiYSI6ImNqeGs0dHAzbTFlb3UzeXFkOWk1ZWQ5cDIifQ.lpPl03eDGutSjsd0fLaPkw"; // Remplace par ta clé API Mapbox
    const endpoint = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
      inputValue
    )}.json`;

    try {
      // Requête GET à l'API Mapbox Geocoding
      const response = await fetch(
        `${endpoint}?access_token=${accessToken}&autocomplete=true&limit=10`
      );

      // Vérification de la réponse
      if (!response.ok) {
        throw new Error("Erreur lors de la récupération des données Mapbox");
      }

      const data = await response.json();

      // Mapper les résultats en un tableau d'options
      return data.features.map((feature: any) => ({
        value: feature.place_name,
        label: feature.place_name,
        lat: feature.center[1], // Latitude
        lon: feature.center[0], // Longitude
      }));
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
      return [];
    }
  };

  const [position, setPosition] = useState<[number, number]>([51.505, -0.09]); // Position initiale (Londres)

  // Gestion de la sélection
  // Gestion de la sélection d'une position
  const handlePositionChange = (option: Option | null) => {
    if (option) {
      // Met à jour l'option sélectionnée dans l'état
      setSelectedOption(option);

      // Met à jour la valeur de l'input avec le label de l'option sélectionnée
      setInputValue(option.label);

      // Déclare explicitement le type de la position comme un tableau de coordonnées [latitude, longitude]
      const newPosition: [number, number] = [option.lat, option.lon];

      // Met à jour la position dans l'état
      setPosition(newPosition);

      // Met à jour la vue sur la carte avec Leaflet, si la référence de la carte existe
      if (mapRef.current) {
        mapRef.current.setView(newPosition, 15); // Zoom sur la position sélectionnée
      }

      // Optionnel : Tu peux aussi enregistrer cette position ou exécuter d'autres actions ici
      console.log("Position sélectionnée :", newPosition);
    } else {
      // Gère le cas où aucune option n'est sélectionnée (par exemple, si l'utilisateur vide le champ)
      setSelectedOption(null);
      setInputValue(""); // Réinitialise l'input à une chaîne vide
      console.log("Aucune position sélectionnée");
    }
  };

  const [isManualMode, setIsManualMode] = useState(true); // Mode manuel ou sélecteur

  const [latitude, setLatitude] = useState<string>(""); // Latitude saisie
  const [longitude, setLongitude] = useState<string>(""); // Longitude saisie

  // Gestion de la recherche manuelle
  const handleManualSearch = () => {
    if (!latitude.trim() || !longitude.trim()) {
      alert("Veuillez entrer une latitude et une longitude !");
      return;
    }

    const lat = parseFloat(latitude);
    const lon = parseFloat(longitude);

    if (isNaN(lat) || isNaN(lon)) {
      alert("Les coordonnées doivent être des nombres valides !");
      return;
    }

    console.log(
      `Recherche manuelle effectuée : Latitude ${lat}, Longitude ${lon}`
    );
    setSelectedOption({
      value: `(${lat}, ${lon})`,
      label: `(${lat}, ${lon})`,
      lat,
      lon,
    });

    // Mettre à jour la carte avec les nouvelles coordonnées
    if (mapRef.current) {
      mapRef.current.setView([lat, lon], 17); // Zoom sur les coordonnées saisies
    }

    // Créer un cercle autour des coordonnées
    const radius = 100; // rayon du cercle en mètres, tu peux le rendre dynamique

    if (featureGroupRef.current) {
      // Crée un cercle Leaflet
      const circle = L.circle([lat, lon], {
        radius: radius,
        color: "blue",
        fillColor: "#30a0ff",
        fillOpacity: 0.4,
      });

      // Ajoute le cercle à la carte
      featureGroupRef.current.addLayer(circle);

      // Ajoute ce cercle à l'état des géofences
      const newGeofence: Geofence = {
        id: L.Util.stamp(circle),
        type: "circle",
        center: [lat, lon],
        radius: radius,
      };

      setGeofences((prev) => [...prev, newGeofence]);

      // Mettre à jour les POI si nécessaire
      refreshPOI([...geofences, newGeofence]);
    }
  };

  const [inputValue, setInputValue] = useState<string>(""); // État pour le texte saisi

  // Gestion des modifications dans le champ
  const handleInputChange = (newValue: string, actionMeta: InputActionMeta) => {
    if (actionMeta.action === "input-change") {
      setInputValue(newValue); // Permet la modification manuelle
    }
  };

  return (
    <>
      <div id="add_alarm_wizard" className="wizard">
        <div className="row">
          <ul className="steps col-md-6 col-sm-4">
            <li data-target="#step1" className={step === 1 ? "active-step" : ""}>
              <span className="badge badge-info">1</span> {translate("Geometry")}{" "}
              <span className="chevron"></span>
            </li>
            <li className="ml-2 mr-2">
              <i className="las la-exchange-alt"></i>
            </li>
            <li
              data-target="#step2"
              className={step === 2 ? "active-step" : ""}
            >
              <span className="badge badge-info">2</span> {translate("Properties")}
              <span className="chevron"></span>
            </li>
          </ul>

          <div
            className="col-md-6 col-sm-4 float-end"
            style={{ margin: "8px 0" }}
          >
            {!isManualMode ? (
              <div className="d-flex align-items-center">
                {/* Mode auto-completion */}
                <div className="flex-grow-1">
                  <AsyncSelect
                    cacheOptions
                    defaultOptions
                    loadOptions={fetchLocations}
                    inputValue={inputValue} // Lie le texte affiché au champ
                    onInputChange={handleInputChange} // Gère les modifications manuelles
                    onChange={handlePositionChange}
                    placeholder="Recherchez un lieu..."
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    menuPortalTarget={document.body}
                  />
                </div>
                <button
                  data-toggle="tooltip"
                  title="Return to address search mode"
                  className="btn btn-link ms-2"
                  onClick={(e) => {
                    e.preventDefault(); // Empêche le rechargement de la page
                    setIsManualMode(true);
                  }}
                >
                  <i className="fas fa-exchange-alt text-primary"></i>
                </button>
              </div>
            ) : (
              <div>
                <div className="form-group d-flex align-items-center gap-3">
                  <input
                    type="text"
                    id="coordinates"
                    className="form-control flex-grow-1"
                    value={
                      latitude || longitude ? `${latitude}, ${longitude}` : ""
                    } // Affiche la valeur seulement si elle existe
                    onChange={(e) => {
                      const input = e.target.value.trim();
                      const [lat, lon] = input
                        .split(",")
                        .map((coord) => coord.trim());
                      setLatitude(lat || ""); // Met à jour la latitude
                      setLongitude(lon || ""); // Met à jour la longitude
                    }}
                    placeholder="Exemple : 48.8566, 2.3522" // Le placeholder s'affiche si aucune valeur
                  />
                  <button
                    className="btn btn-primary"
                    onClick={(e) => {
                      e.preventDefault(); // Empêche le rechargement de la page
                      handleManualSearch();
                    }}
                  >
                    <i className="fas fa-search"></i>
                  </button>
                  <button
                    data-toggle="tooltip"
                    title="Enter the coordinates"
                    className="btn btn-link"
                    onClick={(e) => {
                      e.preventDefault(); // Empêche le rechargement de la page
                      setIsManualMode(false);
                    }}
                  >
                    <i className="fas fa-undo text-primary"></i>
                  </button>
                </div>
              </div>
            )}

            {/* Affichage du résultat sélectionné */}
            {/* {selectedOption && (
                                            <div className="mt-4">
                                                <h5>Résultat :</h5>
                                                <p>
                                                    {selectedOption.label} <br />
                                                    Latitude : {selectedOption.lat}, Longitude : {selectedOption.lon}
                                                </p>
                                            </div>
                                        )} */}
          </div>
        </div>
      </div>
      <div className="step-content col-12">
        <form
          id="add_alarm_form"
          style={{ width: "100%", border: "1px solid #ddd", padding: "15px" }}
        >
          <input type="hidden" name="step" value={step} />
          {step === 1 && (
            <div
              className="step-pane active panel panel-default"
              id="step1"
              style={{ marginTop: "5px", background: "#fff" }}
            >
              <div className="panel-body">
                <div className="row">
                  <div
                    className="col-md-6 col-sm-4"
                    style={{ margin: "8px 0" }}
                  >
                    <div className="input-group">
                      <span className="input-group-addon">
                        <strong>Etape 1 </strong> Déssinez/Choisir vos
                        points/zones géographique
                      </span>
                    </div>
                  </div>

                  <div
                    className="col-md-6 col-sm-4"
                    style={{
                      display: "inline",
                      textAlign: "right",
                      margin: "8px 0",
                    }}
                  >
                    <button
                      className="btn btn-outline-secondary  "
                      type="button"
                      name="set_params"
                      onClick={addPOI}
                    >
                      <i className="fas fa-chevron-right"></i>&nbsp;Suivant
                    </button>
                  </div>
                  <div>
                    <MapContainer
                      center={mapCenter}
                      zoom={mapZoom}
                      style={{ height: "70vh", width: "100%", zIndex: "1" }}
                      ref={mapRef}
                    >
                      <BaseMapLayerControl
                        value={baseMap}
                        onChange={setBaseMap}
                        tokenUrl={`${backendUrl}/api/mapkit/token`}
                      />
                      <div
                        className="geofence-map-search"
                        onClick={(event) => event.stopPropagation()}
                        onMouseDown={(event) => event.stopPropagation()}
                        onDoubleClick={(event) => event.stopPropagation()}
                      >
                        <span className="geofence-map-search__icon">
                          <i className="las la-search" />
                        </span>
                        <AsyncSelect
                          cacheOptions
                          defaultOptions
                          loadOptions={fetchLocations}
                          inputValue={inputValue}
                          onInputChange={handleInputChange}
                          onChange={handlePositionChange}
                          placeholder="Rechercher lieu ou adresse..."
                          classNamePrefix="geofence-map-search-select"
                          styles={{
                            container: (base) => ({ ...base, flex: 1 }),
                            control: (base) => ({
                              ...base,
                              minHeight: 40,
                              border: 0,
                              boxShadow: "none",
                            }),
                            valueContainer: (base) => ({
                              ...base,
                              paddingLeft: 8,
                            }),
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                          menuPortalTarget={document.body}
                        />
                      </div>
                      <FeatureGroup ref={featureGroupRef}>
                        <EditControl
                          ref={editControlRef}
                          position="topleft"
                          onCreated={handleCreated}
                          onEdited={handleEdited}
                          draw={{
                            rectangle: true,
                            polygon: true,
                            circle: true,
                            polyline: true,
                            marker: true,
                            circlemarker: false,
                          }}
                        />
                      </FeatureGroup>
                    </MapContainer>
                  </div>
                </div>
              </div>
            </div>
          )}
          {step === 2 && (
            <div
              className="step-pane panel panel-default"
              id="step2"
              style={{ marginTop: "5px", background: "#fff" }}
            >
              <div className="panel-body">
                <div className="row">
                  <div
                    className="col-md-12"
                    id="alarm_text2"
                    style={{ marginBottom: "15px" }}
                  ></div>
                </div>
                <div className="row" id="criteria" style={{ display: "block" }}>
                  <div
                    className="col-md-12 col-sm-12"
                    style={{ marginTop: "2px" }}
                  >
                    <div className="row">
                      <div
                        className="col-md-6 col-sm-6"
                        style={{ marginTop: "2px" }}
                      >
                        <div className="input-group">
                          <span
                            className="input-group-addon"
                            style={{ paddingRight: " 10px" }}
                          >
                            <strong>Etape 2 </strong> Complétez les informations
                            de la recherche :
                          </span>
                        </div>
                      </div>

                      <div
                        className="ccol-md-6 col-sm-6"
                        style={{
                          display: "inline",
                          textAlign: "right",
                          margin: "8px 0",
                        }}
                      >
                        <button
                          className="btn btn-outline-secondary  mr-2"
                          type="button"
                          name="back"
                          onClick={wizardBack}
                        >
                          <i
                            className="fas fa-chevron-left"
                            style={{ color: "#ff7e41" }}
                          ></i>
                          &nbsp;Précédent
                        </button>

                        <Button
                          onClick={(e) => {
                            e.preventDefault();
                            setButtonClicked(true);

                            id_poi
                              ? fetchVehicles(
                                  POI?.areageof,
                                  "CIRCLE",
                                  startDate.format("YYYY-MM-DD HH:mm:ss"),
                                  endDate.format("YYYY-MM-DD HH:mm:ss")
                                )
                              : fetchVehicles(
                                  POI?.areageof,
                                  "CIRCLE",
                                  startDate.format("YYYY-MM-DD HH:mm:ss"),
                                  endDate.format("YYYY-MM-DD HH:mm:ss")
                                );
                            setButtonClicked(false);
                          }}
                          variant="primary"
                          type="submit"
                          disabled={buttonClicked}
                        >
                          {id_poi
                            ? translate("Save changes")
                            : translate("Check POI")}
                        </Button>
                      </div>
                    </div>
                    <div className="row" style={{ marginTop: "2px" }}>
                      <div className="col-md-4 col-sm-12">
                        <label htmlFor="code_poi">
                          {translate("End start")} :
                        </label>
                        <LocalizationProvider
                          dateAdapter={AdapterDayjs}
                          adapterLocale="fr"
                        >
                          <DateTimePicker
                            //label="Date de début"
                            value={startDate}
                            onChange={handleStartDateChange}
                            ampm={false} // Format 24h
                            format="YYYY-MM-DD HH:mm:ss"
                            maxDate={dayjs()}
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                sx: {
                                  "& .MuiOutlinedInput-root": {
                                    height: 40, // ✅ Réduit la hauteur
                                    fontSize: "14px", // ✅ Texte plus petit
                                    "& fieldset": { borderColor: "#ddd" }, // ✅ Bordure orange
                                    "&:hover fieldset": {
                                      borderColor: "#e76f33",
                                    }, // ✅ Bordure plus foncée au survol
                                    "&.Mui-focused fieldset": {
                                      borderColor: "#d95c1e",
                                    }, // ✅ Bordure plus intense en focus
                                  },
                                  "& .MuiInputLabel-root": {
                                    color: "#ff7e41", // ✅ Couleur du label
                                  },
                                  "& .MuiInputLabel-root.Mui-focused": {
                                    color: "#d95c1e", // ✅ Couleur du label en focus
                                  },
                                },
                              },
                            }} // ✅ Nouvelle méthode
                          />
                        </LocalizationProvider>
                      </div>
                      <div className="col-md-4 col-sm-12">
                        <label htmlFor="code_poi">
                          {translate("End date")} :
                        </label>
                        <LocalizationProvider
                          dateAdapter={AdapterDayjs}
                          adapterLocale="fr"
                        >
                          <DateTimePicker
                            //  label="Date de fin"
                            value={endDate}
                            onChange={handleEndDateChange}
                            ampm={false}
                            format="YYYY-MM-DD HH:mm:ss"
                            maxDate={dayjs()}
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                sx: {
                                  "& .MuiOutlinedInput-root": {
                                    height: 40, // ✅ Réduit la hauteur
                                    fontSize: "14px", // ✅ Texte plus petit
                                    "& fieldset": { borderColor: "#ddd" }, // ✅ Bordure orange
                                    "&:hover fieldset": {
                                      borderColor: "#e76f33",
                                    }, // ✅ Bordure plus foncée au survol
                                    "&.Mui-focused fieldset": {
                                      borderColor: "#d95c1e",
                                    }, // ✅ Bordure plus intense en focus
                                  },
                                  "& .MuiInputLabel-root": {
                                    color: "#ff7e41", // ✅ Couleur du label
                                  },
                                  "& .MuiInputLabel-root.Mui-focused": {
                                    color: "#d95c1e", // ✅ Couleur du label en focus
                                  },
                                },
                              },
                            }} // ✅ Nouvelle méthode
                          />
                        </LocalizationProvider>
                      </div>

                      <div className="col-md-4 col-sm-12">
                        <label htmlFor="id_user">{translate("Group")}:</label>
                        <Selectlist
                          controlId="group"
                          name={"group"}
                          label={translate("Group")}
                          icon="users"
                          options={groupsOptions}
                          valueType={
                            groupId
                              ? {
                                  value: groupId,
                                  label: findGroupById(groupId)?.label || translate("None"),
                                }
                              : {
                                value: 0,
                                label: findGroupById(groupId)?.label || translate("None"),
                              } // Pas de valeur sélectionnée
                          }
                          onChange={(selectedOption) => {
                            const selectedGroupId = selectedOption?.value || 0;
                            setGroupId(selectedGroupId); // on met à jour la variable
                          }}
                        />
                      </div>

                      <div className="col-md-12 col-sm-12">
                        <label htmlFor="code_poi">Vehicle list :</label>
                        {/* Champ de recherche */}
                        <div className="mb-3">
                          <input
                            type="text"
                            placeholder="Search by Immatriculation"
                            className="form-control"
                            value={searchTerm}
                            onChange={(e) => {
                              setSearchTerm(e.target.value);
                              setCurrentPage(1); // Revenir à la première page lors de la recherche
                            }}
                          />
                        </div>
                        {loading ? (
                          <div className="flex justify-center items-center h-screen text-center">
                            <PropagateLoader
                              color={"#123abc"}
                              loading={loading}
                              size={20}
                            />
                          </div>
                        ) : filteredVehicles.length > 0 ? (
                          <>
                            <table className="table table-bordered table-striped mt-3">
                              <thead>
                                <tr>
                                  <th>Immatriculation</th>
                                  <th>Group Of Machines</th>
                                  <th>Entered Location</th>{" "}
                                  {/* User-selected or manually entered location */}
                                  <th>Exit Location</th>
                                  <th>Date</th>
                                </tr>
                              </thead>
                              <tbody>
                                {currentVehicles.map(
                                  (vehicle: Vehicle, index: number) => (
                                    <tr key={index}>
                                      <td>
                                        {vehicle.immatriculation_vehicule}
                                      </td>
                                      <td>{vehicle.nom_groupe}</td>
                                      <td
                                        className="cursor-pointer"
                                        onClick={() =>
                                          setModalInfo({
                                            show: true,
                                            lat: vehicle.entry_lat,
                                            lng: vehicle.entry_lon,
                                          })
                                        }
                                      >
                                        {vehicle.LAT}, {vehicle.LON}
                                      </td>
                                      <td
                                        className="cursor-pointer"
                                        onClick={() =>
                                          setModalInfo({
                                            show: true,
                                            lat: vehicle.exit_lat,
                                            lng: vehicle.exit_lon,
                                          })
                                        }
                                      >
                                        {vehicle.LAT}, {vehicle.LON}
                                      </td>
                                      <td>
                                        {timeZoneDST(vehicle.entry_date)} |{" "}
                                        {timeZoneDST(vehicle.exit_date)}
                                      </td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </table>
                            {/* Pagination */}
                            <p className="mt-3">
                              Affichage {currentVehicles.length} sur{" "}
                              {filteredVehicles.length}
                            </p>
                            <ReactPaginate
                              previousLabel="Previous"
                              nextLabel="Next"
                              breakLabel="..."
                              pageCount={Math.ceil(
                                vehicles.length / limitValue
                              )}
                              marginPagesDisplayed={2}
                              pageRangeDisplayed={3}
                              onPageChange={handlePageClick}
                              containerClassName="pagination justify-content-end"
                              pageClassName="page-item"
                              pageLinkClassName="page-link"
                              previousClassName="page-item"
                              previousLinkClassName="page-link"
                              nextClassName="page-item"
                              nextLinkClassName="page-link"
                              breakClassName="page-item"
                              breakLinkClassName="page-link"
                              activeClassName="active"
                              forcePage={currentPage - 1} // Permet de contrôler la page courante
                            />
                          </>
                        ) : (
                          <p className="mt-3">No vehicles found</p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-md-3 col-sm-3"
                    id="opts_cell"
                    style={{ display: "none", marginTop: "2px" }}
                  ></div>
                  <div
                    className="col-md-3 col-sm-3"
                    id="extra_cell_inline"
                    style={{ display: "none", marginTop: "2px" }}
                  ></div>
                </div>

                <div className="row" style={{ display: "none" }}>
                  <div
                    className="col-md-12"
                    id="extra_cell"
                    style={{ marginTop: "10px" }}
                  ></div>
                </div>
              </div>
            </div>
          )}
        </form>
        <MapModal
          show={modalInfo.show}
          onClose={() => setModalInfo({ show: false, lat: 0, lng: 0 })}
          lat={modalInfo.lat}
          lng={modalInfo.lng}
        />
      </div>
    </>
  );
};

export default POI;
